var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 36C38.8825 36 33.5 30.6175 33.5 24C33.5 17.3825 38.8825 12 45.5 12C52.1175 12 57.5 17.3825 57.5 24C57.5 30.6175 52.1175 36 45.5 36ZM45.5 18C42.1925 18 39.5 20.6925 39.5 24C39.5 27.3075 42.1925 30 45.5 30C48.8075 30 51.5 27.3075 51.5 24C51.5 20.6925 48.8075 18 45.5 18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 69H17C17 53.285 29.785 40.5 45.5 40.5C54.58 40.5 63.195 44.8875 68.5475 52.2325L63.6975 55.765C59.47 49.9625 52.6675 46.4975 45.4975 46.4975C33.09 46.4975 22.9975 56.59 22.9975 68.9975L23 69Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83 60H77V66H83V60Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5979 61.7122L65.4018 64.7122L68.403 69.9105L73.5992 66.9105L70.5979 61.7122Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7173 69.4037L57.7173 74.5999L62.9156 77.6011L65.9156 72.405L60.7173 69.4037Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62 81H56V87H62V81Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9138 90.4013L57.7155 93.4026L60.7155 98.5987L65.9138 95.5975L62.9138 90.4013Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.403 98.0911L65.4017 103.289L70.5979 106.289L73.5991 101.091L68.403 98.0911Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83 102H77V108H83V102Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5983 98.0842L86.4021 101.084L89.4034 106.283L94.5995 103.283L91.5983 98.0842Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0867 90.4026L94.0867 95.5988L99.285 98.6L102.285 93.4039L97.0867 90.4026Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104 81H98V87H104V81Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2858 69.3985L94.0875 72.3998L97.0875 77.5959L102.286 74.5947L99.2858 69.3985Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4019 61.7168L86.4006 66.9151L91.5968 69.9151L94.598 64.7168L89.4019 61.7168Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5025 102.183L87.4975 96.99C89.775 95.6725 91.6725 93.7725 92.99 91.4975L98.1825 94.5025C96.34 97.685 93.685 100.342 90.5 102.185L90.5025 102.183Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4975 71.01C85.225 69.695 82.6325 69 80 69V63C83.685 63 87.3175 63.975 90.5025 65.8175L87.4975 71.01Z",
    fill: "currentColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80 105V99C82.6325 99 85.225 98.305 87.4975 96.99L90.5025 102.183C87.3175 104.025 83.6875 105 80 105Z",
    fill: "currentColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4975 102.182C66.315 100.34 63.6575 97.685 61.815 94.5L67.0075 91.495C68.325 93.7725 70.225 95.67 72.5 96.9875L69.495 102.18L69.4975 102.182Z",
    fill: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80 105C76.315 105 72.6825 104.025 69.4975 102.182L72.5025 96.99C74.775 98.305 77.3675 99 80 99V105Z",
    fill: "currentColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8175 94.5025C59.975 91.3175 59 87.6875 59 84H65C65 86.6325 65.695 89.225 67.01 91.4975L61.8175 94.5025Z",
    fill: "currentColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.01 76.5025L61.8175 73.4975C63.66 70.315 66.315 67.6575 69.5 65.815L72.505 71.0075C70.2275 72.325 68.33 74.225 67.0125 76.5L67.01 76.5025Z",
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5025 71.01L69.4975 65.8175C72.6825 63.975 76.3125 63 80 63V69C77.3675 69 74.775 69.695 72.5025 71.01Z",
    fill: "currentColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1825 94.5025L92.99 91.4975C94.305 89.225 95 86.6325 95 84H101C101 87.685 100.025 91.3175 98.1825 94.5025Z",
    fill: "currentColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.99 76.5025C91.6725 74.225 89.7725 72.325 87.4975 71.01L90.5025 65.8175C93.685 67.66 96.3425 70.315 98.185 73.5L92.9925 76.505L92.99 76.5025Z",
    fill: "currentColor"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65 84H59C59 80.315 59.975 76.6825 61.8175 73.4975L67.01 76.5025C65.695 78.775 65 81.3675 65 84Z",
    fill: "currentColor"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M101 84H95C95 81.3675 94.305 78.775 92.99 76.5025L98.1825 73.4975C100.025 76.6825 101 80.3125 101 84Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.524c178e.svg";
export { ForwardRef as ReactComponent };